import { useFulfiller } from '../FulfillerContext';
import styles from '../App.module.scss';

export const LandingPage = () => {
  const { fulfillerData } = useFulfiller();
  return fulfillerData ? (
    <div className={styles.landingPageMessage}>
      Choose one of the options from the navbar.
    </div>
  ) : (
    <div className={styles.landingPageMessage}>Please select a fulfiller.</div>
  );
};
